module.exports = __webpack_public_path__ + "img/kitazima.c324f1b1.jpg";